import PolicyLayout from '../../components/PolicyLayout';

export default function TermsPage() {
  return (
    <PolicyLayout title="Terms and Conditions" lastUpdated="February 2026">
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">1. Introduction</h2>
        <p className="text-slate-400 mb-4">
          Welcome to StatioPrint, a service provided by StatioMart. By accessing or using our
          website and services at www.statioprint.statiomart.com, you agree to be bound by these
          Terms and Conditions.
        </p>
        <p className="text-slate-400">
          Please read these terms carefully before using our print services. If you do not agree
          with any part of these terms, you may not use our services.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">2. Services</h2>
        <p className="text-slate-400 mb-4">
          StatioPrint provides a QR-based document printing service that allows users to:
        </p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>Upload documents for printing via QR code scanning</li>
          <li>Select print preferences (color, copies, page range)</li>
          <li>Make payments online or choose Cash on Delivery</li>
          <li>Collect printed documents from partner print shops</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">3. User Responsibilities</h2>
        <p className="text-slate-400 mb-4">By using our services, you agree to:</p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>Provide accurate information when using our services</li>
          <li>Not upload any illegal, harmful, or copyrighted content without authorization</li>
          <li>Not misuse or attempt to manipulate our systems</li>
          <li>Collect your printed documents within a reasonable timeframe</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">4. Payments</h2>
        <p className="text-slate-400 mb-4">
          We accept payments through Razorpay and Cash on Delivery. All online transactions are
          processed securely through Razorpay's payment gateway. Prices are displayed in Indian
          Rupees (INR) and are inclusive of applicable taxes.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">5. Intellectual Property</h2>
        <p className="text-slate-400">
          All content on this website, including logos, text, and design, is the property of
          StatioMart and is protected by intellectual property laws. Users retain ownership of their
          uploaded documents.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">6. Limitation of Liability</h2>
        <p className="text-slate-400">
          StatioPrint and StatioMart shall not be liable for any indirect, incidental, or
          consequential damages arising from the use of our services. Our liability is limited to
          the amount paid for the specific transaction in question.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">7. Changes to Terms</h2>
        <p className="text-slate-400">
          We reserve the right to modify these terms at any time. Changes will be effective
          immediately upon posting on our website. Continued use of our services constitutes
          acceptance of the modified terms.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">8. Contact Us</h2>
        <p className="text-slate-400">
          For any questions regarding these terms, please contact us at{' '}
          <a href="mailto:info@statiomart.com" className="text-indigo-400 hover:underline">
            info@statiomart.com
          </a>
        </p>
      </section>
    </PolicyLayout>
  );
}
